export default "__VITE_ASSET__Q23J_jUg__"